import { render, staticRenderFns } from "./ZoneSubzoneVG.vue?vue&type=template&id=2a40652a"
import script from "./ZoneSubzoneVG.vue?vue&type=script&lang=js"
export * from "./ZoneSubzoneVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports